export const AUTH_TAB_SYNC_KEY = 'auth:tabSync'

export type AuthTabSyncScope = 'customer' | 'admin'
export type AuthTabSyncAction = 'signin' | 'signout'

export type AuthTabSyncEvent = {
  scope: AuthTabSyncScope
  action: AuthTabSyncAction
  at: number
  id: string
}

export function broadcastAuthTabSyncEvent(
  scope: AuthTabSyncScope,
  action: AuthTabSyncAction
): void {
  if (typeof window === 'undefined') return

  const event: AuthTabSyncEvent = {
    scope,
    action,
    at: Date.now(),
    id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
  }

  try {
    window.localStorage.setItem(AUTH_TAB_SYNC_KEY, JSON.stringify(event))
  } catch {
    // Ignore storage errors; same-tab state has already been updated.
  }
}

export function parseAuthTabSyncEvent(
  value: string | null | undefined
): AuthTabSyncEvent | null {
  if (!value) return null

  try {
    const parsed = JSON.parse(value) as Partial<AuthTabSyncEvent> | null
    if (!parsed) return null

    const { scope, action, at, id } = parsed

    if (scope !== 'customer' && scope !== 'admin') return null
    if (action !== 'signin' && action !== 'signout') return null
    if (typeof at !== 'number' || typeof id !== 'string') return null

    return {
      scope,
      action,
      at,
      id,
    }
  } catch {
    return null
  }
}
